import { useEffect, useState } from "react";

const WompiPayment = ({ publicKey, amount, reference, signature, currency, expirationTime, guestEmail, guestFullName, guestZipCode, guestPhone, guestDni }) => {
  const [formData, setFormData] = useState({
    amount: "",
    customerData: {
      fullName: "",
      email: "",
      phoneNumber: "",
      phoneNumberPrefix: "+57",
      legalId: "",
      legalIdType: "CC"
    },
    shippingAddress: {
      addressLine1: "",
      addressLine2: "",
      country: "CO",
      city: "",
      region: "",
      phoneNumber: ""
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const keys = name.split(".");
      if (keys.length > 1) {
        return {
          ...prevData,
          [keys[0]]: { ...prevData[keys[0]], [keys[1]]: value }
        };
      }
      return { ...prevData, [name]: value };
    });
  };

  const loadWompiScript = () => {
    const container = document.getElementById("wompi-button-container");
    // Limpia el contenedor para evitar duplicados
    container.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://checkout.wompi.co/widget.js";
    script.setAttribute("data-render", "button");
    script.setAttribute("data-public-key", publicKey);
    script.setAttribute("data-currency", currency);
    script.setAttribute("data-amount-in-cents", amount);
    script.setAttribute("data-reference", reference);
    script.setAttribute("data-signature:integrity", signature);
    script.setAttribute("data-redirect-url", "https://letoh.co/reserved/");
    script.setAttribute("data-expiration-time", expirationTime);
    script.setAttribute("data-customer-data:email", guestEmail);
    script.setAttribute("data-customer-data:full-name", guestFullName);
    script.setAttribute("data-customer-data:phone-number", guestPhone);
    script.setAttribute("data-customer-data:phone-number-prefix", formData.customerData.phoneNumberPrefix);
    script.setAttribute("data-customer-data:legal-id", guestDni);
    script.setAttribute("data-customer-data:legal-id-type", formData.customerData.legalIdType);
    container.appendChild(script);
  };

  useEffect(() => {
    // Inyecta el script del widget tan pronto como el componente se monte
    loadWompiScript();

    const timer = setTimeout(() => {
        const btn = document.querySelector("#wompi-button-container button");
        if (btn) {
          btn.click();
        } else {
          console.error("No se encontró el botón de Wompi para simular el clic.");
        }
      }, 1500); // Ajusta el tiempo según necesites
      return () => clearTimeout(timer);
  }, [publicKey, amount, reference, signature, currency, guestEmail, guestFullName, guestZipCode, guestPhone, guestDni]);

  return (
    <div>
      <div className="hidden" id="wompi-button-container"></div>
    </div>
  );
};

export default WompiPayment;
